<div class="panel-gap">
  <div
    class="trigger-scale-text"
    [innerHTML]="layer.props.legendTriggerScaleText"
  >
    {{ layer.props.legendTriggerScaleText }}
  </div>
</div>
